<template>
  <div>
    <div class="page-banner">
      <div
        class="container"
        style="background-image:url('https://downloads.acs.com.hk/page-headers/2017-technical-enquiry.jpg?5fcee52c50563');"
      >
        <div class="wrapper">
          <div class="content">
            <h1>
              <a
                class="title"
                title="Technical Enquiry"
                href="/en/technical-enquiry/"
                >Technical Enquiry</a
              >
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container technical-enquiry">
      <div class="row">
        <div class="col-md-10 offset-md-1 ">
          <div
            class="page-content"
            itemscope
            itemtype="http://schema.org/WebPage"
          >
            <form
              class="parsley-form technical-enquiry"
              action="/action/forms/"
              data-parsley-validate="true"
              data-parsley-focus="none"
            >
              <input
                type="hidden"
                value="40e0f932be3a3a88adca3b721c73cd1d"
                name="csrf_token"
              />
              <h5>Contact Information</h5>
              <div class="form-group row">
                <div class="col-sm-3">
                  Company Name<span class="acs-red">*</span>
                  :
                </div>
                <div class="col-sm-9">
                  <input
                    class="form-control input-sm"
                    name="company"
                    required=""
                    data-parsley-required-message="Please enter your company."
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-3">
                  Full Name<span class="acs-red">*</span>
                  :
                </div>
                <div class="col-sm-9">
                  <input
                    class="form-control input-sm"
                    name="name"
                    required=""
                    data-parsley-required-message="Please specify your name."
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-3">
                  Email<span class="acs-red">*</span>
                  :
                </div>
                <div class="col-sm-9">
                  <input
                    class="form-control input-sm"
                    name="email"
                    required=""
                    data-parsley-required-message="Please enter your email address."
                    data-parsley-type="email"
                    data-parsley-type-message="Please enter your email address."
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-3">
                  Phone number<span class="acs-red">*</span>
                  :
                </div>
                <div class="col-sm-9">
                  <input
                    class="form-control input-sm"
                    name="telephone"
                    required=""
                    data-parsley-required-message="Please enter your telephone number."
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-3">State:</div>
                <div class="col-sm-9">
                  <select
                    class="form-control input-sm"
                    name="country"
                    required=""
                    data-parsley-required-message="Please select your country."
                  >
                    <option value="Johor">Johor</option
                    ><option value="Kedah">Kedah</option
                    ><option value="Kelantan">Kelantan</option
                    ><option value="Melaka">Melaka</option
                    ><option value="Negeri Sembilan">Negeri Sembilan</option
                    ><option value="Pahang">Pahang</option
                    ><option value="Perak">Perak</option
                    ><option value="Perlis">Perlis</option
                    ><option value="Pulau Pinang">Pulau Pinang</option
                    ><option value="Sabah">Sabah</option
                    ><option value="Sarawak">Sarawak</option
                    ><option value="Selangor">Selangor</option
                    ><option value="Terengganu">Terengganu</option>
                  </select>
                </div>
              </div>
              <h5>Technical Information</h5>
              <div class="form-group row">
                <div class="col-sm-3">Solutions:</div>
                <div class="col-sm-9">
                  <select
                    class="form-control input-sm"
                    name="country"
                    required=""
                    data-parsley-required-message="Please select your country."
                  >
                    <option value="Electronic Point of Sale System (e-POS)"
                      >Electronic Point of Sale System (e-POS)</option
                    ><option value="Procurement">Procurement</option
                    ><option value="ERP / Accounting">ERP / Accounting</option
                    ><option value="HR / Payroll system / CRM"
                      >HR / Payroll system / CRM</option
                    ><option value="Digital Marketing / Sales"
                      >Digital Marketing / Sales</option
                    >
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-3">
                  Message :
                </div>
                <div class="col-sm-9 readers">
                  <textarea
                    rows="4"
                    class="form-control input-sm"
                    name="steps_for_error"
                  ></textarea>
                </div>
              </div>
              <div class="form-group row">
                <div class="offset-sm-3 col-sm-9">
                  <div id="container">
                    <span id="screenshots">
                      <i class="ion-android-attach"></i>
                      <span
                        >Attach Screenshots of Error Encountered (1MB
                        max.)</span
                      >
                    </span>
                  </div>
                  <ul id="attachments"></ul>
                  <div id="attachments-fields"></div>
                </div>
              </div>
              <div class="form-group row">
                <div class="offset-sm-3 col-sm-9">
                  <p>
                    <small class="acs-red">* Required field</small>
                  </p>
                  <button
                    id="btn_submit"
                    data-sending="Sending"
                    data-submit="Submit"
                    type="submit"
                    class="btn btn-outline-primary"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TechnicalEnquiry"
};
</script>
